export default __webpack_public_path__ + "static/media/ic_wmetis_30.d55344cd.svg";